import { generateShortId } from '@/utils/crypto.js'

interface OCM_Operation {
  id: string
  isCanceled: Boolean
  isRemoved: Boolean
  remove: Function
  shouldContinue: Function
  logAbort: Function
}
interface OperationCancelManager {
  operations: OCM_Operation[]
  thereArePendingOperations: Function
  createNew: Function
  remove: Function
  cancelAnyOperationInProgress: Function
}

/**
 * Allow to identify and mark operations as canceled.
 *
 * @returns operation cancel manager instance
 */
export function createOperationCancelManager(label = '') {
  let scope: OperationCancelManager = {
    operations: [],
    thereArePendingOperations() {
      return scope.operations.length > 0
    },
    createNew(): OCM_Operation {
      let item = {
        id: generateShortId('id-'),
        isCanceled: false,
        isRemoved: false,
        cancel() {
          item.isCanceled = true
          console.log('op', label, 'canceled', item.id)
        },
        remove() {
          item.isRemoved = true
          scope.remove(item)
        },
        shouldContinue() {
          if (!item.isCanceled) {
            return true
          } else {
            !item.isRemoved && scope.remove(item.id)
            return false
          }
        },
        logAbort(msg = '') {
          console.log(label, 'abort!', item.id, msg)
        },
      }
      scope.operations.push(item)
      return item
    },
    remove(id: string) {
      //console.log('op',label, 'removed', id)
      scope.operations.splice(
        scope.operations.findIndex((item) => item.id == id),
        1
      )
    },
    cancelAnyOperationInProgress() {
      console.log(label, ' will abort (all)')
      scope.operations.forEach((item) => {
        item.isCanceled = true
      })
    },
  }
  return scope
}

export interface createCooldownStateType {
  isOnCooldown: Function
  cooldown: Function
}

/**
 * Delay or skip logic if cooldown
 * @returns
 */
export function createCooldownState() {
  let timestamp: number | null = null
  return {
    isOnCooldown: (diffInMilliseconds: number = 500) => {
      let _isOnCooldown = timestamp
        ? Date.now() - timestamp <= diffInMilliseconds
        : false
      if (!_isOnCooldown) {
        timestamp = null
      }
      console.log('isOnCooldown', _isOnCooldown)
      return _isOnCooldown
    },
    cooldown() {
      timestamp = Date.now()
    },
  }
}
